module.exports = __webpack_public_path__ + "static/media/th-room.bdbd9fd6.svg";